import { render, staticRenderFns } from "./UpdateAddressModal.vue?vue&type=template&id=7bf5c8e0&scoped=true&"
import script from "./UpdateAddressModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAddressModal.vue?vue&type=style&index=0&id=7bf5c8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf5c8e0",
  null
  
)

export default component.exports